var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8532 7.3341L16.6657 11.1447L12.8532 7.3341ZM15.3048 3.97709L4.99621 14.2857C4.46356 14.8176 4.1003 15.4953 3.9522 16.2333L3 20.9998L7.76642 20.0458C8.50442 19.8982 9.18122 19.5364 9.71403 19.0035L20.0227 8.69491C20.3324 8.38513 20.5782 8.01738 20.7458 7.61263C20.9135 7.20789 20.9998 6.77409 20.9998 6.336C20.9998 5.89791 20.9135 5.46411 20.7458 5.05937C20.5782 4.65463 20.3324 4.28687 20.0227 3.97709C19.7129 3.66732 19.3451 3.42159 18.9404 3.25394C18.5356 3.08629 18.1018 3 17.6638 3C17.2257 3 16.7919 3.08629 16.3871 3.25394C15.9824 3.42159 15.6146 3.66732 15.3048 3.97709V3.97709Z",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.922073d6.svg";
export { ForwardRef as ReactComponent };